module.exports = "<div class=\"sidepage\" modal-box tabindex=\"-1\">\n    <div ui-view></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidepage/template.html
// module id = ./pages/xo-sidepage/template.html
// module chunks = 0